export const JAVA_API_URL = `${window.location.origin}/ws`
export const BO_API_URL = `${window.location.origin}/api/v1`
export const BO_API_URL3 = `${window.location.origin}/api/v3`
export const MAIN_API_URL = `${window.location.origin}/api/v2`
export const SHIVA_KNOWLEDGE_BASE_URL = `https://know.test.karmanow.com/api/`
export const FLAGS_BASE_URL = `https://${
  process.env.REACT_APP_HOST || window.location.host
}/images/country-flags`

export const N8N_FINANCE_WEBHOOK_URL = `https://orsosso.app.n8n.cloud/webhook${ window.location.host === 'backoffice.karmanow.com' ? '' : '-test' }/b4102bf0-e987-4821-9fbb-f542152319dc`
